type CrewParticipantLike = {
  boatId?: string | null;
};

export function findCrewForBoat<T extends CrewParticipantLike>(
  participants: T[],
  boatId: string,
): T[] {
  return participants.filter((participant) => participant.boatId === boatId);
}

export function boatIsPending(boat: { status?: string | null }): boolean {
  return boat.status === "PENDING";
}
